import { earlyRequestClient } from '../earlyRequestorClient';
export const IP_LOCATION_REQUEST_KEY = 'ip-location';
export const IP_LOCATION_URL = '/acquisition/v1/iplocation/info';
export const makeIpLocationEarlyRequest = () => {
  earlyRequestClient.get({
    apiUrl: `${IP_LOCATION_URL}`,
    earlyRequestKey: IP_LOCATION_REQUEST_KEY
  });
};